export const districtRecFn = ({
  map, layerGroup, clearFlag = true,
  closeFn, createBeforeFn,
  width = 5,
})=>{
  if(!map){
    return undefined;
  }
  const recSize = width * 1000;
  let districtRec;
  const districtInit = ()=>{
    map.on('zoomend', districtSelect);
    map.on('mousemove', districtSelect);
    map.on('click', districtCreate);
    map.on('contextmenu', districtClose);
    map.flyTo(map.getCenter(), 11);
  },
  districtClose = ()=>{
    map.off('zoomend', districtSelect);
    map.off('mousemove', districtSelect);
    map.off('click', districtCreate);
    map.off('contextmenu', districtClose);
    districtRecClear();
  },
  districtRecClear = ()=>{
    if(districtRec){
      (layerGroup || map).removeLayer(districtRec);
      districtRec = undefined;
    }
  }
  const districtSelect = (event)=>{
    if(event.type == 'mousemove'){
      districtRecInit(event.latlng, event.target.getZoom());
    }else if(event.type == 'zoomend'){
      let latlng = L.latLng(districtRec?districtRec.getLatLng():map.getCenter());
      districtRecInit(latlng, event.target.getZoom());
    }
  },
  districtRecInit = (latlng, zoom)=>{
    // console.log(latlng, zoom);
    const icon = districtRecIcon(latlng, zoom);
    if(districtRec){
      districtRec.setLatLng(latlng);
      districtRec.setIcon(icon);
    }else{
      districtRec = L.marker(latlng, {
        icon,
      }).addTo(layerGroup || map);
    }
  },
  districtRecIcon = (latlng, zoom)=>{
    const recBounds = latlng.toBounds(recSize),
      recBorderSize = parseInt(
        Math.abs(
          map.project(recBounds.getNorthEast(), zoom).x
          - map.project(recBounds.getSouthWest(), zoom).x
        )
      );
    return L.divIcon({
      className: 'district-rec',
      iconSize: recBorderSize,
    })
  }
  const recConfig = {
    fillOpacity: 0,
    color: 'var(--borderColor)',
  }
  const districtCreate = (event)=>{
    const updateRecCenter = (e)=>{
      const latlng = e.latlng,
            bounds = latlng.toBounds(recSize);
      rec.setBounds(bounds);
    }
    const rec = L.rectangle(event.latlng.toBounds(recSize), {
      ...recConfig,
    }).on({
      // mousedown: event=>{
      //   map.on('mousemove', updateRecCenter);
      //   map.dragging.disable();
      // },
      // mouseup: event=>{
      //   map.off('mousemove', updateRecCenter);
      //   map.dragging.enable();
      // }
    })
    createBeforeFn && createBeforeFn(rec);
    // rec.addTo(layerGroup || map)
    map.fitBounds(rec.getBounds());
    districtClose();
  }

  return districtInit;
  const controlList = [
    { svgName: 'district-select', title: `区域选择（${width}×${width} km²）`, fun: districtInit, }
  ]
  if(clearFlag){
    controlList.push(
      { title: '清除', className: 'district-clear', fun: closeFn, svgName: 'district-clear' }
    );
  }
  return controlList;
  return svgControlCreateMulti(controlList,'district-select-control');
}